// extracted by mini-css-extract-plugin
module.exports = {"code":"Home_code__1-FDA"};